import { COMPONENTS, DeepPartial, NextQueriesConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_NEXT_QUERIES_CONFIG: DeepPartial<NextQueriesConfig> = {
  withResults: false,
  components: {
    nextQuery: {
      footer: COMPONENTS.PURE.ChevronRightIcon
    }
  }
};

export const DESKTOP_NEXT_QUERIES_CONFIG: DeepPartial<NextQueriesConfig> = {
  components: {
    nextQuery: {
      grid: 'GoccoSlidingPanel',
      header: 'GoccoHeaderNextQuery'
    }
  },
  withResults: true,
  pageFrequency: 1,
  results: 8
};
